import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { fetchProductProtocols } from "@/lib/api";

// Product page: concerns ticked on this product's Protocol record. Each chip
// opens the Protocol Builder with that concern preselected.
export default function ProductProtocolsSection({ productRecordId, dealerSlug }) {
  const [concerns, setConcerns] = useState([]);

  useEffect(() => {
    if (!productRecordId) return;
    let active = true;
    fetchProductProtocols(productRecordId)
      .then((d) => active && setConcerns(d?.concerns || []))
      .catch(() => active && setConcerns([]));
    return () => {
      active = false;
    };
  }, [productRecordId]);

  if (!concerns.length) return null;
  return (
    <section className="rounded-2xl border border-zinc-200 bg-white p-4" data-testid="product-protocols">
      <div className="flex items-center gap-2 mb-2">
        <Sparkles size={15} className="text-violet-600" />
        <h2 className="text-sm font-semibold text-zinc-900">Protocols &amp; Concerns</h2>
        <Link to={`/protocols/flyer?d=${dealerSlug}&ids=${productRecordId}`} className="ml-auto text-xs font-semibold text-[#0b2545] hover:underline" data-testid="product-flyer-link">
          Create flyer
        </Link>
        <Link to={`/d/${dealerSlug}?view=protocols`} className="text-xs font-semibold text-violet-700 hover:underline" data-testid="product-protocols-builder-link">
          Build your protocol →
        </Link>
      </div>
      <p className="text-xs text-zinc-500 mb-2.5">This product is part of the OreVital protocol for:</p>
      <div className="flex flex-wrap gap-1.5">
        {concerns.map((c) => (
          <Link
            key={c}
            to={`/protocols/${c.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}?d=${dealerSlug}`}
            className="rounded-full border border-violet-200 bg-violet-50 px-2.5 py-1 text-xs font-medium text-violet-800 hover:bg-violet-600 hover:text-white hover:border-violet-600 transition-colors"
            data-testid={`product-protocol-${c.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
          >
            {c}
          </Link>
        ))}
      </div>
    </section>
  );
}
